<template>
  <div class="dropdown-block">
    <div class="heading">
      {{ label }}
      <span class="link" v-if="link" @click="openAid(type, tab, subtype)">{{ $t('general.helpTool') }}</span>
      <img v-if="toolTip" :src="getImage('question-icon.svg')" alt="" @click="openPopup">
    </div>

    <div class="input-group">
      <input type="number" class="form-control" v-model.number="ownValue" @input="debouncedInput">
      <div class="input-group-append">
        <span class="input-group-text">{{ unit }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import ItemIcon from '../../input/InformationIcon'
import CoddInputNumber from '../../input/Number'
import {mapGetters} from 'vuex';
import tooltipMixin from "../../../mixins/tooltipMixin";

function debounce(func, delay) {
  let timeoutId;
  return function (...args) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
}

export default {
  name: 'MenuItemNumber',
  mixins: [tooltipMixin],
  props: {
    label: {
      default: 'Placeholder label'
    },
    val: {
      default: 0
    },
    unit: {
      type: String,
      default: ''
    },
    link: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: '',
    },
    subtype: {
      type: String,
      default: '',
    },
    tab: {
      type: Number,
      default: 1,
    }
  },
  data() {
    return {
      ownValue: this.val,
    }
  },
  components: {
    ItemIcon,
    CoddInputNumber,
  },
  methods: {
    input(e) {
      let value = e.target.value;

      this.ownValue = value;
      this.$emit('input', value);
      this.$emit('change', value);
    },
    openAid(type, tab, subtype) {
      this.$store.commit('preference/openAid', {type, tab, subtype});
    },
    openPopup() {
      this.$store.commit('tooltips/setCurrentActive', this.toolTip);
    },

    debouncedInput: debounce(function (e) {
      this.input(e);
    }, 500),

  },
  computed: {
    ...mapGetters({
      tooltips: 'tooltips/getAll',
    })
  },
  watch: {
    val: {
      deep: true,
      handler(val) {
        this.ownValue = val;
      }
    }
  }
}
</script>

